
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesscopymachines",
      function () {
        return require("private-next-pages/businesscopymachines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesscopymachines"])
      });
    }
  